<template>
  <div class="block">
    <slot/>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="sass">
.block
  padding: 24px 24px 32px 24px
  border-radius: 10px
  background-color: #fff
</style>